var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIItemChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_16896",
    "data-name": "Group 16896",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16.53,
    viewBox: "0 0 18 16.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38950",
    "data-name": "Path 38950",
    d: "M87.4,48.554a.724.724,0,0,0-.677.772c.021.232.032.452.032.671a6.818,6.818,0,1,1-3.138-5.739.724.724,0,0,0,.777-1.221,8.253,8.253,0,0,0-4.449-1.3h0a8.265,8.265,0,0,0,0,16.53l.172-.011v0A8.287,8.287,0,0,0,88.2,49.988c0-.266-.012-.535-.038-.807A.713.713,0,0,0,87.4,48.554Z",
    transform: "translate(-71.674 -41.735)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38951",
    "data-name": "Path 38951",
    d: "M89.462,42.679a.743.743,0,0,0-1.028,0l-7.581,7.582-2.8-2.8a.73.73,0,0,0-1.029,0,.725.725,0,0,0,0,1.027l3.313,3.31a.726.726,0,0,0,.51.213h.077l0,0a.718.718,0,0,0,.439-.208l8.094-8.094A.727.727,0,0,0,89.462,42.679Z",
    transform: "translate(-71.674 -41.735)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIItemChecked);
export default __webpack_public_path__ + "static/media/i-item-checked.526154be34c61fbe30ea2441e14558fa.svg";
export { ForwardRef as ReactComponent };